import React, { useState } from 'react';
import CPPUtils from 'services/CPPUtils';
import Icon from 'components/Utils/NewIcon';
import { setFormValues } from 'hooks/useReduxForm';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';
import ConfirmationIcon from 'components/Utils/NewIcon/ConfirmationIcon';
import { Physician } from '../../../../../generated/api';

const ACTIVE_TAB = 'referral';

interface CPPTimelineReferralProps {
  referral: any;
  patient: any;
  setActiveCPPTab: (tab: string) => void;
}

const CPPTimelineReferral = ({ referral, patient, setActiveCPPTab }: CPPTimelineReferralProps) => {
  const dispatch = useAppDispatch();

  const physicians = useAppSelector((state) => state.physicians.byId);
  const authentication = useAppSelector((state) => state.authentication);

  const [deletingReferral, setDeletingReferral] = useState(false);

  function onOpen() {
    let data = referral;
    setActiveCPPTab(ACTIVE_TAB);
    const formName = CPPUtils.getFormName(ACTIVE_TAB, referral.patient_id);
    dispatch(setFormValues({ formName, values: { ...data } }));
  }

  function isIntern() {
    let physician = physicians[authentication.user!.id!] || authentication.user;
    return !!(physician as Physician).intern_of;
  }

  async function deleteReferralWrapper() {
    setDeletingReferral(true);
    await dispatch(api.HealthRecords.deleteReferral({ id: referral.id, patientId: patient.id }), {
      errorTitle: 'Delete Referral',
    });
    setDeletingReferral(false);
  }

  let { send_to = {}, waiting_approval, physician_id, text } = referral;

  let description = send_to.name;
  let rootClassName = waiting_approval ? 'greyed-out' : '';
  let isAuthorized = !isIntern() || physician_id === authentication.user!.id!;

  return (
    <div className="item-wrapper clickable" onClick={onOpen}>
      <div className={rootClassName}>
        {isAuthorized && (
          <div className="hover-icons">
            <ConfirmationIcon
              src="trash"
              alt="Delete"
              height="20px"
              className="trash"
              confirmText="Confirm delete?"
              loading={deletingReferral}
              onClick={(event: React.MouseEvent) => {
                event.preventDefault();
                event.stopPropagation();
                deleteReferralWrapper();
              }}
            />
          </div>
        )}
        <div className="top-bar">
          <Icon src="user-doctor" />
          <span className="small-title">Referral</span>
        </div>
        <div className="item-content">
          <div className="inline-block">
            {!!waiting_approval && <span className="bold inline-block">[NOT APPROVED]</span>}
            <span>{description}</span>
          </div>
          <pre className="block">{text}</pre>
        </div>
      </div>
    </div>
  );
};

export default CPPTimelineReferral;
